'use strict';

angular
    .module('directives.userRequests')
    .controller('userRequestNotStartedActionsController',
    ['$scope', '$state', 'selfAccessRequestService', 'employeeService', '$modal','$timeout',
            function ($scope, $state, selfAccessRequestService, employeeService, $modal, $timeout) {
        
        // Get User Identity
        employeeService.getEmployeeIDByAuthentication()
                       .then(function (empIdentity) {
                           $scope.empIdentity = empIdentity;
                       })

        // Get Owner infos
        if ($scope.model.IsSelfAccessRequestOwned) {
            employeeService.getEmployeeBasicInfos($scope.model.SelfRequestOwnerID)
                           .then(function (response) {
                               $scope.reqOwner = response.data;
                           })
        }

     
        // Show Go To Self Service Request?
        $scope.showGoToSelfServiceRequest = function () {
            if (_.isUndefined($scope.empIdentity)) return;
            if (!$scope.model.IsSelfAccessRequestOwned) return false;

            return $scope.model.SelfRequestOwnerID === $scope.empIdentity.EmployeeID;
        }
        
        // Go To Self Service Request
        $scope.goToSelfServiceRequest = function (req) {
            $state.go('selfAccessRequest', {
                userAccessRequestId: req.UserAccessRequestID
            });
        }

        // Show Takeover action?
        $scope.showTakeoverAction = function () {
            if (_.isUndefined($scope.empIdentity)) return;
            if (!$scope.model.IsSelfAccessRequestOwned) return false;

            return $scope.model.SelfRequestOwnerID !== $scope.empIdentity.EmployeeID;
        }

        // Take Ownership of Self Access Request
        $scope.takeOwnershipOfSelfAccessRequest = function (request) {
            selfAccessRequestService
                         .takeOwnershipOfSelfAccessRequest(request.UserAccessRequestID)
                         .then($scope.goToSelfServiceRequest);
        }

        

        // Takeover Self Access Request
        $scope.takeoverSelfAccessRequest = function (request) {
            selfAccessRequestService
                         .takeoverSelfAccessRequest(request.UserAccessRequestID)
                         .then($scope.goToSelfServiceRequest);
        }

        // Delete Ad Hoc Request
        $scope.deleteAdHocSelfAccessRequest = function (request) {
            selfAccessRequestService
                         .deleteAdHocSelfAccessRequest(request.UserAccessRequestID)
                         .then(function () {
                             $state.reload();
                         });
        }
        
        // Take Self Access Request and process it as Draft
        $scope.setSelfAccessRequestToUserAccessRequest = function (request) {
            selfAccessRequestService
                         .setSelfAccessRequestToUserAccessRequest(request.UserAccessRequestID)
                         .then(function (req) {
                             $state.go('userAccessRequest.edit', {
                                 userAccessRequestId: req.UserAccessRequestID
                             }, {reload:true});
                         });
        }

    }]);